import { useEffect, useState } from 'react'

import { FixedPictureFieldModel, RemoteFile } from '@types'

import { useFilePreviews } from '@hooks/file/file-preview.hook'

import { UploadPicture } from '@components/UploadPicture'

type SubmitterFieldFixedPictureProps = {
  field: FixedPictureFieldModel
}

export const SubmitterFieldFixedPicture: React.FC<SubmitterFieldFixedPictureProps> = ({
  field,
}: SubmitterFieldFixedPictureProps) => {
  const [remoteFiles, setRemoteFiles] = useState<RemoteFile[]>([])

  const { loadFilePreviews } = useFilePreviews({
    files: field.files as RemoteFile[],
    onFilesLoaded: (files) => (files ? setRemoteFiles(files as RemoteFile[]) : undefined),
  })

  useEffect(() => {
    if (field.files) {
      loadFilePreviews()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <UploadPicture multiple disabled label={field.label} required={false} files={remoteFiles} setFiles={() => {}} />
  )
}
